// ═══════════════════════════════════════
// Zumo Web → Zumo API (same domain)
// No CORS. No proxy. Just works.
// ═══════════════════════════════════════

const API = 'https://zumo-api.megan.qzz.io'

function getToken(): string | null { return localStorage.getItem('zumo_token') }
function setToken(t: string | null) { t ? localStorage.setItem('zumo_token', t) : localStorage.removeItem('zumo_token') }

async function zumo(path: string, options: RequestInit = {}): Promise<any> {
  const token = getToken()
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers as any || {}),
    },
  })
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}

export async function login(email: string, password: string) {
  const data = await zumo('/v1/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) })
  if (data.token) setToken(data.token)
  return data
}
export async function signup(username: string, email: string, password: string) {
  const data = await zumo('/v1/auth/signup', { method: 'POST', body: JSON.stringify({ username, email, password }) })
  if (data.token) setToken(data.token)
  return data
}
export async function verifySession() {
  try { const data = await zumo('/v1/auth/verify', { method: 'POST' }); return { valid: data.valid, user: data.user } }
  catch { return { valid: false } }
}
export async function logout() { try { await zumo('/v1/auth/logout', { method: 'POST' }) } catch {}; setToken(null) }

export function getMe() { return zumo('/v1/users/me') }
export function searchUsers(q: string) { return zumo(`/v1/users/search?q=${encodeURIComponent(q)}`) }
export function getConversations() { return zumo('/v1/conversations') }
export function createConversation(type: string, members: string[], title?: string) {
  return zumo('/v1/conversations', { method: 'POST', body: JSON.stringify({ type, members, title }) })
}
export function getMessages(convoId: string, limit = 50) { return zumo(`/v1/conversations/${convoId}/messages?limit=${limit}`) }
export function sendMessage(convoId: string, text: string, options?: any) {
  return zumo(`/v1/conversations/${convoId}/messages`, { method: 'POST', body: JSON.stringify({ text, type: 'text', ...options }) })
}
export function reactToMessage(msgId: string, emoji: string) { return zumo(`/v1/messages/${msgId}/react`, { method: 'POST', body: JSON.stringify({ emoji }) }) }
export function pinMessage(msgId: string) { return zumo(`/v1/messages/${msgId}/pin`, { method: 'POST' }) }
export function starMessage(msgId: string) { return zumo(`/v1/messages/${msgId}/star`, { method: 'POST' }) }
export function editMessage(msgId: string, text: string) { return zumo(`/v1/messages/${msgId}`, { method: 'PUT', body: JSON.stringify({ text }) }) }
export function deleteMessage(msgId: string) { return zumo(`/v1/messages/${msgId}`, { method: 'DELETE' }) }
export function forwardMessage(msgId: string, convoId: string) { return zumo(`/v1/messages/${msgId}/forward`, { method: 'POST', body: JSON.stringify({ conversation_id: convoId }) }) }
export function getFriends() { return zumo('/v1/friends') }
export function getFriendRequests() { return zumo('/v1/friends/requests') }
export function sendFriendRequest(username: string) { return zumo('/v1/friends/request', { method: 'POST', body: JSON.stringify({ username }) }) }
export function acceptFriendRequest(requestId: string) { return zumo('/v1/friends/accept', { method: 'POST', body: JSON.stringify({ requestId }) }) }
export function blockUser(userId: string) { return zumo('/v1/friends/block', { method: 'POST', body: JSON.stringify({ user_id: userId }) }) }
export function getWebSocketUrl(roomId: string): string {
  const token = getToken()
  return `wss://zumo-api.megan.qzz.io/v1/ws?room_id=${roomId}&token=${token || ''}`
}
export type User = any
